import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LayoutComponent } from '../../shared/components/layout/layout.component';
import { ClaimsComponent } from './claims.component';
import { ClaimEditComponent } from './components/edit/claim-edit.component';
import { ClaimEditResolver } from './components/edit/claim-edit.resolver';
import { ClaimListComponent } from './components/list/claim-list.component';
import { ClaimHelpComponent } from './components/help/claim-help.component';
import { BankSuccessComponent } from './components/payee/components/bank-success/bank-success.component';
import { DetailComponent } from './components/detail/detail.component';
import { DraftListComponent } from './components/draft-list/draft-list.component';
import { MessageListComponent } from './components/message-list/message-list.component';
import { MessageAdjusterComponent } from './components/message-adjuster/message-adjuster.component';
import { digitalWalletResolver, payorResolver } from 'src/app/resolvers/logged-in.resolver';
import { Auth0GuardService } from 'src/app/core/services/auth0-guard.service';
import { MultiClaim2Component } from './components/multi-claim2/multi-claim2.component';

@NgModule({
  imports: [RouterModule.forChild([
    {
      path: '',
      component: LayoutComponent,
      children: [
        {
          path: '',
          component: ClaimsComponent,
          canActivate: [Auth0GuardService],
          children: [
            {
              path: '',
              component: ClaimListComponent
            },
            {
              path: 'new',
              component: ClaimEditComponent,
              resolve: { prefetch: ClaimEditResolver },
            },
            {
              path: 'message-list',
              component: MessageListComponent 
            },
            {
              path: 'message-adjuster',
              component: MessageAdjusterComponent
            },
            {
              path: 'draft-list',
              component: DraftListComponent
            },
            {
              path: 'MultiClaim',
              component: MultiClaim2Component,
            },
            {
              path: 'MultiClaim2',
              component: MultiClaim2Component,
            },
            {
              path: 'help',
              component: ClaimHelpComponent,
            },
            {
              path: 'detail',
              component: DetailComponent
            }
          ],
        }
      ],
      resolve: {
        dwDetails: digitalWalletResolver,
        payorDetails: payorResolver
      }
    },
    {
      path: 'bankSuccess', component: BankSuccessComponent
    }
  ])],
  exports: [RouterModule],
})
export class ClaimsRoutingModule {
}
